import API from "../API";
import axios, { AxiosRequestConfig } from "axios";

declare const LogAndNotification: string;
export default class NotificationAPI extends API {
  constructor() {
    super("notification", LogAndNotification);
  }

  async getUserNotifications(
    userId: string,
    roleId: string,
    teamIds: string[]
  ) {
    axios.defaults.baseURL = LogAndNotification;
    
    return axios.get(`get/user/notification/${userId}`, {
      params: {
        role_id: roleId ?? "",
        team_ids: teamIds?.length ? teamIds : [], // Axios will serialize array properly
      },
    });
  }

  async markAsRead(id: string, userId: string) {
    axios.defaults.baseURL = LogAndNotification;

    return axios.post(`mark-notification-read/${id}`, { user_id: userId });
  }

  async markAllAsRead(userId: string) {
    axios.defaults.baseURL = LogAndNotification;
    return axios.post(`mark-all-notifications-read/${userId}`);
  }
}
